// extracted by mini-css-extract-plugin
export default {"chart_icon":"CoachingPerformanceViewResults_chart_icon__wAfL6"};